import React from "react";

import { useI18next } from "@herob191/gatsby-plugin-react-i18next";
import { Footer } from "./footer";
import { Header } from "./header";

export default function Layout({ children, showLangSwitch = true }) {
  const { languages, originalPath } = useI18next();
  return (
    <>
      <div className="container">
        <header className="site-header text-light">
          <div className="container">
            <Header siteTitle={"Oscar Stories"} headerRight={!showLangSwitch} />
          </div>
        </header>
        {/* <div className="bg-fill-1" />
        <div className="bg-fill-2" />
        <div className="bg-fill-3" /> */}

        <main>{children}</main>
        <Footer showLangSwitch={showLangSwitch} />
      </div>
    </>
  );
}
